import React from "react";

export interface NarrationPanelProps {
  /** Current narration text to display */
  text?: string;
  /** Whether narration is actively playing */
  isActive?: boolean;
  /** Node title displayed above narration */
  nodeTitle?: string;
}

export const NarrationPanel: React.FC<NarrationPanelProps> = ({
  text,
  isActive = false,
  nodeTitle,
}) => {
  if (!text && !nodeTitle) return null;

  return (
    <div className={`narration-panel ${isActive ? "active" : ""}`}>
      {nodeTitle && (
        <div className="narration-header">
          <div className="narration-indicator" />
          <span className="narration-node-title">{nodeTitle}</span>
        </div>
      )}
      {text && (
        <p className="narration-text">{text}</p>
      )}
    </div>
  );
};
